module.exports = __webpack_public_path__ + "media/images/red-notes-1f87ca524caaf126a6ede0b9dae0530e.svg";